import Icon from "@Components/generic/icon";
import TooltipWrapperV2 from "@Components/generic/tooltip-wrapper-v2";
import getMetricLabel from "@Containers/app/stat-cards/tooltips/get-metric-label";
import getMetricTooltip from "@Containers/app/stat-cards/tooltips/get-metric-tooltip";
import MetricEventTypes from "@Enums/MetricEventTypes";
import { faInfoCircle } from "@fortawesome/pro-solid-svg-icons";
import useI18n from "@i18n";
import { Card, Stack, Typography, useTheme } from "@mui/material";

interface ICareerTargetCard {
  metric: MetricEventTypes;
  score: number;
}

const CareerTargetCard = ({ metric, score: _score }: ICareerTargetCard) => {
  const { i18n } = useI18n();
  const theme = useTheme();

  const formatScore = (metric: MetricEventTypes, score: number): string | number => {
    if (metric === MetricEventTypes.CRITICAL_SCAN) {
      return (score / 100).toFixed(2);
    } else if (metric === MetricEventTypes.SCAN_FREQUENCY) {
      return (score * 0.009).toFixed(2);
    }
    return score;
  };

  const formattedScore = formatScore(metric, _score);

  return (
    <Card
      variant="outlined"
      sx={{
        minWidth: theme.spacing(25),
        borderRadius: theme.spacing(2),
        backdropFilter: `blur(${theme.spacing(1.25)})`,
        backgroundColor: `${theme.palette.dsSurface.v100}80`,
        border: `1px solid ${theme.palette.dsSurface.v400}80`,
        padding: theme.spacing(3.25),
        boxSizing: "border-box",
      }}
    >
      <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ marginBottom: theme.spacing(3) }}>
        <Stack direction="row" spacing={1} alignItems="center">
          <Typography variant="textLg500" color="dsNeutral.v300">
            {i18n(`metric.${metric}.name`)}
          </Typography>
        </Stack>

        <TooltipWrapperV2 tooltipComponent={getMetricTooltip(metric)}>
          <Icon
            icon={faInfoCircle}
            sx={{
              cursor: "pointer",
              fontSize: theme.spacing(2.5),
              color: theme.palette.dsNeutral.v300,
            }}
          />
        </TooltipWrapperV2>
      </Stack>

      <Stack direction="row" alignItems="end">
        <Typography variant="text4xl700" color="dsBase.v200" sx={{ lineHeight: theme.spacing(3.5) }}>
          {formattedScore}
        </Typography>
        <Typography
          variant="text2xl500"
          color="dsNeutral.v300"
          sx={{
            marginLeft: theme.spacing(0.5),
            lineHeight: theme.spacing(3),
          }}
        >
          {i18n(getMetricLabel(metric).short)}
        </Typography>
      </Stack>
    </Card>
  );
};

export default CareerTargetCard;
